import type { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';

import { Text } from '../primitives/Text';
import { useTheme } from '../theme/ThemeProvider';

export type SectionHeaderProps = {
  title: string;
  actions?: ReactNode;
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

export function SectionHeader({
  title,
  actions,
  style,
  testID,
}: SectionHeaderProps) {
  const theme = useTheme();

  return (
    <View
      testID={testID}
      style={[
        styles.header,
        { gap: theme.spacing(2), paddingHorizontal: theme.spacing(1), paddingTop: theme.spacing(2) },
        style,
      ]}
    >
      <View style={styles.titles}>
        <Text
          variant="label"
          style={[
            styles.title,
            { fontSize: theme.fontSize.xs, color: theme.colors.textMuted },
          ]}
        >
          {title}
        </Text>
      </View>

      {actions}
    </View>
  );
}

const styles = StyleSheet.create({
  header: { flexDirection: 'row', alignItems: 'center' },
  titles: { flex: 1 },
  title: { letterSpacing: 0.6, textTransform: 'uppercase' },
});
